// @flow
import React, {useReducer} from 'react';

import {CheckoutDispatchContext, useCheckout} from './dispatch';
import {CheckoutStateContext, DEFAULT_STATE, stateReducer, useCheckoutState} from './state';

type CheckoutProviderProps = {
  children: React$Node,
};

const CheckoutProvider = ({children}: CheckoutProviderProps): React$Node => {
  const [state, dispatch] = useReducer(stateReducer, DEFAULT_STATE);

  return (
    <CheckoutStateContext.Provider value={state}>
      <CheckoutDispatchContext.Provider value={dispatch}>{children}</CheckoutDispatchContext.Provider>
    </CheckoutStateContext.Provider>
  );
};

const withCheckout =
  (component: React$ComponentType<any>): (any => React$Node) =>
  (props: any) =>
    <CheckoutProvider>{React.createElement(component, props)}</CheckoutProvider>;

export {CheckoutProvider, withCheckout, useCheckout, useCheckoutState};
